import { dateFunc } from "@/components/Functions/dateFunc";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const useColumnTasksDefs=() =>{
  const { caseId } = useSelector((state: any) => state.case);
  
  const {t}=useTranslation()
  return [
  {
    field: "claimReference",
    type:"claimReferenceType",
    headerName: t("pages.tasks.columnDetails.claimId"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
    cellRenderer: "claimCellRenderer",
  },
  {
    cellRenderer: "name",
    field: "name",
    type:"nameType",
    headerName: t("pages.tasks.columnDetails.taskName"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
  },
  {
    field: "type",
    type:"typeType",
    cellRenderer: "typeCellRenderer",
    headerName: t("pages.tasks.columnDetails.type"),
    flex:1, 
    minWidth: 150,
    sortable: true,
    unSortIcon: true,
  },

  {
    flex:1,
    minWidth: 150,
    field: "dueDate",
    type:"dueDateType",
    headerName: t("pages.tasks.columnDetails.dueDate"),
    sortable: true,
    unSortIcon: true,
    cellRenderer: function (params: any) {
        return dateFunc(params.data.dueDate).formattedDateOnly;
      }
  },
  {
    field: "status",
    type:"statusType",
    headerName:  t("pages.tasks.columnDetails.status"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
    cellRenderer: "statusCellRenderer",
  },
  {
    field: "creditorName",
    type:"creditorNameType",
    headerName:  t("pages.tasks.columnDetails.creditorName"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
    cellRenderer: (params:any)=>{
      return params.data.creditorName?<Link to={`/case/${caseId}/creditor/${params.data.creditorId}`}><span className="text-bold-underline">{params.data.creditorName}</span></Link>:"-";

    },
  },
  {
    field: "createdBy",
    type:"createdByType",
    headerName:  t("pages.tasks.columnDetails.createdBy"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
    cellRenderer: (params:any)=>{
      return params.data.createdBy?params.data.createdBy:"-";

    },
  }, {
    field: "createdOn",
    type:"createdDateType",
    headerName:  t("pages.tasks.columnDetails.createdDate"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
    cellRenderer: (params:any)=>{
      return params.data.createdOn?dateFunc(params.data.createdOn).formattedDateOnly:"-";

    },
  }, {
    field: "updatedBy",
    type:"updatedByType",
    headerName:  t("pages.tasks.columnDetails.updatedBy"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
    cellRenderer: (params:any)=>{
      return params.data.updatedBy?params.data.updatedBy:"-";

    },
  }, {
    field: "updatedOn",
    type:"updatedOnType",
    headerName:  t("pages.tasks.columnDetails.updatedOn"),
    sortable: true,
    unSortIcon: true,
    flex:1,
    minWidth: 150,
    cellRenderer: (params:any)=>{
      return params.data.updatedOn?dateFunc(params.data.updatedOn).formattedDateOnly:"-";

    },
  }, 
]};
